import { useRef } from "react";

interface UseDragWithClickResult {
  onPointerDown: () => void;
  onPointerMove: () => void;
  onPointerUp: () => void;
  isDragging: boolean;
}

interface UseDragWithClickProps {
  onClick: () => void;
  onDragStart?: () => void;
  onDragEnd?: () => void;
  longClickThreshold?: number;
}
export const useDragWithClick = ({
  onClick, 
  onDragStart,
  onDragEnd,
  longClickThreshold = 200
}: UseDragWithClickProps): UseDragWithClickResult => {
  const pointerDownTimeRef = useRef<number | null>(null);
  const isDraggingRef = useRef(false);

  const onPointerDown = () => {
    isDraggingRef.current = false;
    pointerDownTimeRef.current = Date.now();
    onDragStart?.();
  };

  const onPointerMove = () => {
    isDraggingRef.current = true;
  };

  const onPointerUp = () => {
    onDragEnd?.();
    
    const isLongClick = pointerDownTimeRef.current && (Date.now() - pointerDownTimeRef.current) > longClickThreshold;
    if (isDraggingRef.current || isLongClick) {
      isDraggingRef.current = false;
      return;
    }
    
    onClick();
    pointerDownTimeRef.current = null;
  };

  return {
    onPointerDown,
    onPointerMove,
    onPointerUp,
    isDragging: isDraggingRef.current
  };
};
